import { createSlice } from "@reduxjs/toolkit";
import { isAiFulfilled } from "../apis/aiApi";

export const AI_PROVIDERS = ["gpt", "gemini"];

const initialState = {
    provider: "gpt", // user's model choice, sent as `provider` to business-setup endpoints
};

const aiSlice = createSlice({
    name: "ai",
    initialState,
    reducers: {
        setProvider: (state, { payload }) => {
            if (AI_PROVIDERS.includes(payload)) {
                state.provider = payload;
            }
        },
    },
    extraReducers: (builder) => {
        // When the service had to fall back (e.g. GPT → Gemini), keep using the provider that worked,
        // matching the old per-page `setSelectedModel("gemini")` behaviour.
        builder.addMatcher(isAiFulfilled, (state, { payload }) => {
            const { fellBack, provider } = payload?.meta || {};
            if (fellBack && AI_PROVIDERS.includes(provider)) {
                state.provider = provider;
            }
        });
    },
});

export const { setProvider } = aiSlice.actions;

export const selectAiProvider = (state) => state.ai.provider;

export default aiSlice.reducer;
